import React from 'react';
import ReactDOM from 'react-dom';
import Dict from 'dict-lib';
import {AdministrationUtilities} from "../administration/AdministrationHelper";
import {LexemeUtilities} from "../lexeme/page/editor/LexemeHelper";

const TranslationMap = {
    'AUTO': 'auto',
    'LLD-GHE': 'lagh',
    'LLD-BAD': 'lavb',
    'DEU': 'tedesco',
    'ENG': 'inglese',
    'ITA': 'ita'
};

export const TranslationService = {

    translateText: async function(text, langInDizCode, langOutDizCode) {
        text = LexemeUtilities.encodeUrl(text);
        return Dict.call('appService/translateText/' + text + '/' + langInDizCode + '/' + langOutDizCode + '/')/*.then((result) => {
            var result = { translation: result.target, error: result.error, message: result.message}
            return result;
        });*/


        /*const langIn = TranslationMap[langInDizCode];
        const langOut = TranslationMap[langOutDizCode];

        const formData = new URLSearchParams();
        formData.append("text", text);
        formData.append("source", langIn);
        formData.append("target", langOut);

        try {
            const response = await fetch('https://tradutur-informatik.uibk.ac.at/api', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: formData.toString(),
            });

            const data = await response.json();
            return data;

            //if (data.success) {
            //    text = data.source;
            //    this.translatedText = data.target;
            //    langOut = data.target_lang;
            //    langIn = data.source_lang;
            //    this.isCopied = false;
            //}
        } catch (error) {
            console.error('Error translating text:', error);
        } finally {
            //this.loading = false;
        }*/
    }
}
export default TranslationService

